// Mock data for Miela Maison luxury website
// Enhanced with e-commerce metadata for future Shopify integration

export const products = [
  {
    id: 1,
    sku: 'MM-BDI-CF-250',
    slug: 'burundi-single-origin-coffee',
    category: 'coffee',
    translationKey: 'burundiSingleOrigin',
    name: 'Burundi Single-Origin',
    origin: 'Burundi',
    description: 'Exceptional high-altitude specialty coffee with notes of dark chocolate, black cherry, and caramel.',
    altitude: '1700-2000m',
    process: 'Fully Washed',
    flavor: ['Dark Chocolate', 'Black Cherry', 'Caramel', 'Citrus'],
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/f1jdlx3a_image.png',
    price: '¥3,800 / 250g',
    priceAmount: 3800,
    currency: 'JPY',
    weight: '250g',
    inStock: true,
    shopifyProductId: null,
    metaTitle: 'Premium Burundi Single-Origin Coffee | MIELA MAISON',
    metaDescription: 'Exceptional high-altitude specialty coffee from Burundi with notes of dark chocolate, black cherry, and caramel. 100% Arabica, fully washed, ethically sourced.'
  },
  {
    id: 2,
    sku: 'MM-RWA-CF-250',
    slug: 'rwanda-single-origin-coffee',
    category: 'coffee',
    translationKey: 'rwandaSingleOrigin',
    name: 'Rwanda Single-Origin',
    origin: 'Rwanda',
    description: 'Vibrant and complex with floral aromatics, red fruit, and a silky body.',
    altitude: '1800-2100m',
    process: 'Natural',
    flavor: ['Red Berries', 'Floral', 'Stone Fruit', 'Honey'],
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/7gg8etch_image.png',
    price: '¥4,200 / 250g',
    priceAmount: 4200,
    currency: 'JPY',
    weight: '250g',
    inStock: true,
    shopifyProductId: null,
    metaTitle: 'Premium Rwanda Single-Origin Coffee | MIELA MAISON',
    metaDescription: 'Vibrant and complex specialty coffee from Rwanda with floral aromatics, red fruit, and silky body. 100% Arabica, natural process, ethically sourced.'
  },
  {
    id: 3,
    sku: 'MM-BDI-HN-500',
    slug: 'burundi-raw-wildflower-honey',
    category: 'honey',
    translationKey: 'burundiRawWildflowerHoney',
    name: 'Burundi Raw Wildflower Honey',
    origin: 'Burundi',
    description: 'Unheated, raw honey harvested from wildflowers in pristine East African highlands.',
    floral: 'Wildflower',
    benefits: ['Raw & Unprocessed', 'Rich in Antioxidants', 'Natural Enzymes', 'Single-Source'],
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/99djitjk_image.png',
    price: '¥5,400 / 500g',
    priceAmount: 5400,
    currency: 'JPY',
    weight: '500g',
    inStock: true,
    shopifyProductId: null,
    metaTitle: 'Burundi Raw Wildflower Honey | MIELA MAISON',
    metaDescription: 'Premium raw, unheated wildflower honey from Burundi. Rich in antioxidants and natural enzymes. Single-source, ethically harvested from pristine East African highlands.'
  },
  {
    id: 4,
    sku: 'MM-RWA-HN-500',
    slug: 'rwanda-mountain-honey',
    category: 'honey',
    translationKey: 'rwandaMountainHoney',
    name: 'Rwanda Mountain Honey',
    origin: 'Rwanda',
    description: 'Premium raw honey from high-altitude mountain flora, amber in color with complex flavor.',
    floral: 'Mountain Flora',
    benefits: ['Unheated', 'Rich Mineral Content', 'Complex Flavor', 'Ethically Sourced'],
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/7fz5p3v2_image.png',
    price: '¥6,200 / 500g',
    priceAmount: 6200,
    currency: 'JPY',
    weight: '500g',
    inStock: true,
    shopifyProductId: null,
    metaTitle: 'Rwanda Mountain Honey | MIELA MAISON',
    metaDescription: 'Premium raw honey from high-altitude mountain flora in Rwanda. Amber in color with complex flavor, rich in minerals. Unheated and ethically sourced.'
  },
  {
    id: 5,
    category: 'whisky',
    translationKey: 'premiumJapaneseWhisky',
    name: 'Premium Japanese Whisky Selection',
    origin: 'Japan',
    description: 'Curated selection of exceptional Japanese whisky from award-winning distilleries.',
    age: 'Various',
    type: 'Single Malt & Blended',
    image: 'https://images.unsplash.com/photo-1648231839575-65864b75fa2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxKYXBhbmVzZSUyMHdoaXNreXxlbnwwfHx8fDE3ODE3NjMwMTF8MA&ixlib=rb-4.1.0&q=85',
    price: 'Contact for Pricing'
  },
  {
    id: 6,
    category: 'tea',
    translationKey: 'premiumJapaneseGreenTea',
    name: 'Premium Japanese Green Tea',
    origin: 'Japan',
    description: 'First-flush sencha and gyokuro from prestigious tea gardens in Kyoto and Shizuoka.',
    type: 'Sencha & Gyokuro',
    grade: 'Premium First Flush',
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/i77ynms1_image.png',
    price: '¥4,800 / 100g'
  },
  {
    id: 7,
    category: 'cosmetics',
    translationKey: 'japaneseCosmeticsCollection',
    name: 'Japanese Cosmetics Collection',
    origin: 'Japan',
    description: 'Premium skincare and beauty products featuring traditional Japanese ingredients.',
    ingredients: ['Rice Bran', 'Camellia Oil', 'Green Tea Extract', 'Sake'],
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/ftwe36ei_image.png',
    price: 'Various'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Takeshi Yamamoto',
    position: 'Head Buyer, Luxury Department Store Tokyo',
    content: 'Miela Maison has transformed our specialty coffee offering. The quality and traceability of their Burundi and Rwanda coffees are unmatched in the Japanese market.',
    rating: 5
  },
  {
    id: 2,
    name: 'Yuki Tanaka',
    position: 'Owner, Artisan Café Kyoto',
    content: 'The honey from Miela Maison is exceptional—truly raw and unprocessed. Our customers appreciate the authentic story behind each jar.',
    rating: 5
  },
  {
    id: 3,
    name: 'Sarah Mitchell',
    position: 'International Buyer, European Distributor',
    content: 'Working with Miela Maison on Japanese whisky exports has been seamless. Their expertise in international trade and quality control is outstanding.',
    rating: 5
  }
];

export const origins = [
  {
    id: 'burundi',
    country: 'Burundi',
    description: 'Nestled in the heart of East Africa, Burundi produces some of the world most exceptional specialty coffee. Our partnerships with local farmers ensure sustainable practices and premium quality.',
    products: ['Specialty Coffee', 'Raw Honey'],
    altitude: '1700-2100m',
    climate: 'Tropical Highland',
    image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_miela-luxury/artifacts/lehipqmc_image.png'
  },
  {
    id: 'rwanda',
    country: 'Rwanda',
    description: 'The Land of a Thousand Hills produces coffee and honey of extraordinary quality. Our direct relationships with cooperatives ensure fair compensation and sustainable growth.',
    products: ['Specialty Coffee', 'Mountain Honey'],
    altitude: '1800-2300m',
    climate: 'Temperate Tropical',
    image: 'https://images.unsplash.com/photo-1645480057118-20bb6112ab43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxBZnJpY2FuJTIwY29mZmVlJTIwZmFybXxlbnwwfHx8fDE3ODE3NjI5NzZ8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 'japan',
    country: 'Japan',
    description: 'From prestigious whisky distilleries to ancient tea gardens, Japan represents centuries of craftsmanship. We curate and export the finest Japanese products to international markets.',
    products: ['Whisky', 'Green Tea', 'Cosmetics'],
    heritage: 'Centuries of Craftsmanship',
    philosophy: 'Perfection Through Detail',
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/mum49oh4_image.png'
  }
];

export const values = [
  {
    id: 'ethicalSourcing',
    title: 'Ethical Sourcing',
    description: 'Direct relationships with producers ensuring fair compensation and sustainable practices.',
    icon: 'heart-handshake'
  },
  {
    id: 'premiumQuality',
    title: 'Premium Quality',
    description: 'Rigorous quality control at every stage, from farm to final delivery.',
    icon: 'award'
  },
  {
    id: 'culturalConnection',
    title: 'Cultural Connection',
    description: 'Building bridges between Africa and Japan through exceptional products and mutual respect.',
    icon: 'globe'
  },
  {
    id: 'transparency',
    title: 'Transparency',
    description: 'Complete traceability and transparency in our supply chain.',
    icon: 'eye'
  },
  {
    id: 'sustainability',
    title: 'Sustainability',
    description: 'Environmental stewardship and long-term partnerships that benefit communities.',
    icon: 'leaf'
  },
  {
    id: 'excellence',
    title: 'Excellence',
    description: 'Uncompromising standards in product selection, handling, and customer service.',
    icon: 'sparkles'
  }
];

export const categories = [
  {
    id: 'coffee',
    name: 'Specialty Coffee',
    subtitle: 'From Burundi & Rwanda',
    description: 'Single-origin beans from high-altitude farms',
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/2r53od5t_image.png'
  },
  {
    id: 'honey',
    name: 'Raw Honey',
    subtitle: 'Unheated & Natural',
    description: 'Premium honey from pristine East African highlands',
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/x9l26uyv_image.png'
  },
  {
    id: 'whisky',
    name: 'Japanese Whisky',
    subtitle: 'Premium Selection',
    description: 'Curated collection from renowned distilleries',
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/l324kcid_image.png'
  },
  {
    id: 'tea',
    name: 'Japanese Tea',
    subtitle: 'Premium Ocha',
    description: 'First-flush sencha and gyokuro from prestigious gardens',
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/i77ynms1_image.png'
  },
  {
    id: 'cosmetics',
    name: 'Japanese Cosmetics',
    subtitle: 'Traditional Beauty',
    description: 'Premium skincare with traditional ingredients',
    image: 'https://customer-assets.emergentagent.com/job_miela-luxury/artifacts/ftwe36ei_image.png'
  }
];